<template>
  <div class="shuzi">
    <div class="shuzi-top">
      <div class="top-left animate__animated wow animate__fadeInLeft">
        <h2>
          Cover multi-scenario of conventional marketing of healthcare companies
        </h2>
        <p>
          Digital transformation is closely linked to the development of new
          business models. precision marketing solutions based on big data in
          finance.
        </p>
        <ul class="btn-card">
          <li><a>Department meeting</a></li>
          <li><a>Annual Academic Conference</a></li>
          <li><a>Satellite meeting</a></li>
          <li><a>Knowledge competition</a></li>
          <li><a>Online consultation</a></li>
          <li><a>Survey questionnaire</a></li>
          <li><a>Case collection</a></li>
          <li><a>Chronic disease management</a></li>
          <li><a>Popular science and patient education</a></li>
        </ul>
      </div>
      <div class="top-right animate__animated wow animate__fadeInRight">
        <div class="right-box">
          <el-carousel
            :autoplay="false"
            indicator-position="none"
            arrow="always"
          >
            <el-carousel-item v-for="(item, index) in lunboList" :key="index">
              <img :src="item" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="shuzi-main animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard
          title="A new generation of solutions for the digital transformation of enterprises."
        ></titleCard>
      </div>
      <div class="content">
        <img
          src="../../assets/image/innovatc/shuzi2.png"
          alt=""
          class="pcPic"
        />
      </div>
    </div>
    <div class="shuzi-bottom animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="GRC transformation of enterprises"></titleCard>
      </div>
      <div class="content">
        <img src="../../assets/image/innovatc/shuzi3.png" />
      </div>
    </div>
    <footerCard name="Mr Wu" phone="138-1097-5144"></footerCard>
  </div>
</template>

<script>
import footerCard from "../../components/footer-card.vue";
import titleCard from "../../components/title-card.vue";
export default {
  data() {
    return {
      lunboList: [
        require("../../assets/image/innovatc/lunbo2/lunbo1.webp"),
        require("../../assets/image/innovatc/lunbo2/lunbo1.webp"),
        require("../../assets/image/innovatc/lunbo2/lunbo1.webp"),
      ],
    };
  },
  components: {
    footerCard,
    titleCard,
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.shuzi {
  .shuzi-top {
    display: flex;
    // height: 7.4737rem;
    @media screen and (max-width: 540px) {
      flex-wrap: wrap;
    }
    .top-left {
      box-sizing: border-box;
      width: 50%;
      @media screen and (max-width: 540px) {
        width: 100%;
        text-align: center;
        padding: 15px;
        padding-top: 45px;
      }
      padding: 1.5263rem 1.6842rem;
      h2 {
        margin: 0;
        margin-bottom: 0.3158rem;
        font-size: 0.4421rem;
        color: #272b2d;
        font-weight: 700;
        @media screen and (max-width: 540px) {
          font-size: 21px;
        }
      }
      p {
        font-size: 0.2947rem;
        color: #6a7073;
        padding-bottom: 0.6316rem;
        @media screen and (max-width: 540px) {
          font-size: 14px;
          padding-bottom: 25px;
        }
      }
      .btn-card {
        overflow: hidden;
        @media screen and (max-width: 540px) {
          width: 100%;
        }
        li {
          float: left;
          width: 33.3%;
          padding: 0 0.1842rem;
          box-sizing: border-box;
          height: 0.6737rem;
          height: 50px;
          margin-bottom: 0.3579rem;
          @media screen and (max-width: 540px) {
          }
          a {
            cursor: pointer;
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            border-radius: 0.3368rem;
            background-color: #fbfbfb;
            font-size: 0.162rem;
            color: #616161;
            height: 100%;
            font-weight: 300;
            @media screen and (max-width: 540px) {
              height: 100%;
              border-radius: 25px;
              font-size: 13px;
            }
          }
          a:hover {
            background-color: #06aef9;
            color: #fff;
          }
        }
      }
    }
    .top-right {
      width: 50%;
      @media screen and (max-width: 540px) {
        width: 100%;
      }
      display: flex;
      justify-content: center;
      align-items: center;
      .right-box {
        width: 7.7684rem;
        height: 4.3789rem;
        @media screen and (max-width: 540px) {
          width: 80%;
          height: 230px;
        }
        /deep/ .el-carousel__arrow {
          height: 1.7789rem;
          background-color: #06aef9;
          width: 0.7368rem;
          border-radius: 0;
          color: #fff;
          font-size: 0.2737rem;
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
        /deep/ .el-carousel__item {
          img {
            width: 100%;
            height: 100%;
          }
        }
        /deep/ .el-carousel-item {
          width: 100%;
          height: 100%;
        }
        /deep/ .el-carousel__arrow--left {
          left: -0.7368rem;
        }
        /deep/ .el-carousel__arrow--right {
          right: -0.6842rem;
        }
        /deep/ .el-carousel__container {
          width: 6.3158rem;
          margin: 0 auto;
          height: 4.3789rem;
          @media screen and (max-width: 540px) {
            width: 100%;
            height: 230px;
          }
        }
      }
    }
  }
  .shuzi-main {
    height: 11.3684rem;
    width: 100%;
    background: url("../../assets/image/innovatc/shuzi-bg.png") no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 580px;
      background: url("../../assets/image/innovatc/shuziios.png") no-repeat;
      background-size: 100% 100%;
    }
    .title {
      padding-top: 1.1158rem;
      padding-bottom: 1.5789rem;
    }
    .content {
      width: 60%;
      margin: 0 auto;
      text-align: center;
      @media screen and (max-width: 540px) {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        img {
          display: none;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .shuzi-bottom {
    padding-bottom: 1rem;
    .title {
      margin: 1.0526rem 0 0.7895rem 0;
      @media screen and (max-width: 540px) {
        margin-bottom: 56px;
      }
    }
    .content {
      margin: 0 auto;
      height: 6.3158rem;
      width: 12.3158rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        height: 200px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
